import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { equals } from 'ramda'
import PropTypes from 'prop-types'
import { Form, Formik } from 'formik'
import { Button, Typography } from '@material-ui/core'

import OTPInput from 'app/componentV4/Input/OTPInput'
import PanelsIllustrationMSG from 'app/componentV4/Panels/IllustrationMSG'

const VerificationWithOTP = (props) => {
  const {
    email = '',
    onSubmit = () => {},
    reference = '',
    onBack = () => {},
    isError,
    reFreshOtp = () => {},
  } = props
  const [seconds, setSeconds] = useState(60)
  const [active, setActive] = useState(true)

  useEffect(() => {
    if (!active) return

    if (seconds === 0) {
      setActive(false)
      return
    }

    const timer = setTimeout(() => {
      setSeconds((prev) => prev - 1)
    }, 1000)

    return () => clearTimeout(timer)
  }, [seconds, active])

  const handleResend = () => {
    reFreshOtp()
    setSeconds(60)
    setActive(true)
  }

  return (
    <PanelsIllustrationMSG isClickBack={true} onBack={() => onBack()}>
      <div className="flex justify-center items-center h-full">
        <div className="w-full">
          {/* Header */}
          <Typography className="text-18 font-500 text-primary text-center">
            {'OTP verification'}
          </Typography>

          <div className="my-10">
            <Typography className="text-14 text-grey-400 text-center">
              {'We have sent a verification code to'}
            </Typography>
            <Typography className="text-14 font-bold text-grey-400 text-center break-all">
              {email}
            </Typography>
          </div>

          <Typography className="text-14 text-grey-400 text-center my-10">
            {'ref: '}
            <span>{reference}</span>
          </Typography>
          <Formik
            initialValues={{ otp: '' }}
            validationSchema={Yup.object({
              otp: Yup.string()
                .length(6, 'OTP must be 6 digits')
                .required('Required'),
            })}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <OTPInput
                  name="otp"
                  length={6}
                  variant="outlined"
                  value={values.otp}
                  onChange={(val) => {
                    setFieldValue('otp', val)
                    if (val.length === 6) {
                      !equals(values.otp, val) && onSubmit(val)
                    } else return
                  }}
                  inputProps={{ 'aria-label': 'Verify OTP', error: isError }}
                  className="mx-auto space-x-5 md:space-x-10 w-fit"
                />
              </Form>
            )}
          </Formik>
          <div className="flex w-fit mx-auto space-x-1">
            <Typography className="text-14 text-grey-400 text-center my-10">
              {'Didn’t get the OTP?'}
            </Typography>
            {active ? (
              <Typography className="text-12 text-grey-200 text-center my-10 flex items-center font-500">
                {`Resend Email in ${seconds}s`}
              </Typography>
            ) : (
              <Button
                className={
                  'p-0 text-secondary text-12 font-400 normal-case disabled:text-secondary hover:bg-transparent text-nowrap'
                }
                onClick={handleResend}
              >
                {'Resend Now'}
              </Button>
            )}
          </div>
        </div>
      </div>
    </PanelsIllustrationMSG>
  )
}

VerificationWithOTP.propTypes = {
  onBack: PropTypes.func,
  isError: PropTypes.bool,
  email: PropTypes.string,
  onSubmit: PropTypes.func,
  reFreshOtp: PropTypes.func,
  reference: PropTypes.string,
}

export default VerificationWithOTP
